import './NewRequestPanel.css';
import sunGlyph from '../Images/sun-glyph.png';
import magnifyingGlassGlyph from '../Images/magnifying-glass-glyph.png';
import FDNYWhite from '../Images/fdny-white-logo.png';
import GeoBadge from '../Images/geo-fence.png';

const NewRequestPanel = () => {
    return <div className="grid-parent new-request-layout">
        <span className="title new-request-title">New Request</span>
        <div className="time-display">
            <span className="time-span">8:10 AM</span>
            <span className="month-span">Oct 30</span>
            <span id="weather-img"><img id="sun-glyph" src={sunGlyph} alt="sun"/></span>
            <span className="temp-span">48°</span>
        </div>

        <div className="incident-box panel-sm">Incident</div>
        <div className="ems-box panel-sm">EMS</div>
        <div className="fdny-box panel-sm">FDNY</div>

        <div className="geo-fence-section">
            <img class="geo-badge-img" src={GeoBadge} alt="Golden geo badge" />
            <div class="geo-text-p">
                ENCRYPTED <br/>
                Geo-Data by Design
            </div>
        </div>

        <div className="search-box">
            <img className="magnifying-glass-glyph" src={magnifyingGlassGlyph} alt="Magnifying Glass" />
            <span className="search-span">Search</span>
        </div>

        <div className="address-box">
            <span id="address">Address</span>
            <div className="address-grouping">
                <span id="house-number">270</span><br/>
                <span id="street-name">West End Ave</span><br/>
                <span id="state-zip">NY 10023</span>
            </div>
        </div>

        <div className="unit-box panel-lg-vert">
            <span id="unit">Unit</span>
            <div className="fdny-grouping">
                <span id="fdny"><img src={FDNYWhite} className="fdny-white-logo" alt="FDNY logo"/></span><br/>
                <span id="eng-number">ENGINE 72</span>
            </div>
            <span id="full-address">120 W 83rd St</span>
        </div>

        <div className="id-box panel-med">
            <span id="id">ID</span>
            <span id="id-number"># 2819</span>
        </div>

        <div className="eta-box panel-med">
            <span id="eta">ETA</span>
            <span id="time">07:20</span>
        </div>

        <div className="activate-box panel-lg-hor">
            <span id="activate">Activate</span>
        </div>
    </div>
}

export default NewRequestPanel;